import Vue from 'vue'

import ElementAddress from 'element-address'
import 'element-address/lib/index.css'

Vue.use(ElementAddress)
